import BaseAPI from '../base'

function getAll() {
    return BaseAPI.get(`currency/all`);
}

function getById(id) {
    return BaseAPI.get(`currency/info/${id}`);
} 

export default {
    getAll,
    getById
}